// react and js
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// mui
import { Grid, Stack, Box } from "@mui/material";

// components
import CardOutlet from "./CardOutlet";

// hooks

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
function MissingContent({ message }) {
  // ----------------------------------------------------------------------
  // Properties
  // ----------------------------------------------------------------------
  MissingContent.propTypes = {
    message: PropTypes.string.isRequired,
  };

  const { t } = useTranslation();

  return (
    <Grid item xs={12} md={12} lg={12}>
      <Box>
        <Stack spacing={2}>
          <Box
            sx={{
              boxShadow: "0px 0px 0px 0px rgba(0,0,0,0.5)",
            }}
          >
            <CardOutlet
              variant="outlet"
              backgroundProp="#F2F2F2"
              title={t("components.missingContent.title", { message })}
              error={Boolean(true)}
              returnMessage={t("components.missingContent.connectionError")}
            />
          </Box>
        </Stack>
      </Box>
    </Grid>
  );
}

export default MissingContent;
